export default {
  "logoLink": "https://www.atfx.com/it",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "Licenza FCA",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "Apri un conto live per tradare Forex e CFD | ATFX UK",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "Spread bet e CFD sono strumenti complessi e presentano un alto rischio di perdere denaro rapidamente a causa della leva. La stragrande maggioranza dei conti dei clienti retail perde denaro quando scambia CFD. Dovresti considerare se puoi permetterti di correre il rischio elevato di perdere i tuoi soldi.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "Il 59.38% dei conti degli investitori al dettaglio perde denaro quando trada i CFD con questo fornitore.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "Apri un conto live ATFX forex e CFD con un broker regolamentato FCA del Regno Unito. Spread bassi, leva 1:30, piattaforma MT4, supporto clienti 24/5. Registrati ora!",
  "policyBarClose": 'La Societa ha preso la decisione di cessare di fornire servizi ai clienti retail, con effetto immediato.  Non possiamo quindi accogliere alcuna domanda.<br />I servizi ai clienti professionali non saranno influenzati.  Per le applicazioni professionali, contattare <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'Utilizziamo cookie per fornire la migliore esperienza d’uso del nostro sito. Continuando a navigare, acconsenti all’utilizzo dei cookie. <a title="[Leggi oltre]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Leggi oltre]</a>',
  "policyBarButton":'Accetta',
  "header": {
    "registration": "APERTURA CONTO",
    "personalDetails1": "Informazioni personali 1",
    "personalDetails2": "Informazioni personali 2",
    "financialDetails": "Informazioni finanziarie",
    "Experience": "Esperienza di trading",
    "Knowledge": "Conoscenza del trading",
    "Acknowledgements": "Riconoscimenti",
    "previewPage":"anteprima",
    "liveTrading": "TRADING REALE"
  },
  footer:{//修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. Tutti i diritti riservati.",
    "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener">Politica sulla privacy</a>',
    "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">Politica sui cookie</a>',
    "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">Termini e condizioni</a>',
    "Legal":"APRI UN CONTO REALE Nota legale: AT Global Markets (UK) Limited è autorizzato e regolamentato dalla Financial Conduct Authority (FCA) del Regno Unito. Numero di registrazione FCA (760555). Sede legale: 1st Floor, 32 Cornhill, London EC3V 3SG, United Kingdom. Società n. 09827091",
    "riskWaring":'AVVISO DI INVESTIMENTO AD ALTO RISCHIO: I CFD sono strumenti complessi e presentano un alto rischio di perdere rapidamente denaro a causa della leva finanziaria. <strong>Il 59.38% dei conti degli investitori al dettaglio perde denaro quando trada i CFD con questo fornitore. </strong>Dovresti considerare se comprendi come funzionano i CFD e se puoi permetterti di correre il rischio elevato di perdere i tuoi soldi. Si prega di leggere il documento <a title = "Standard Terms of Business" href = "https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target = "_ blanck" > Standard Terms of Business </a>.',
    "otherInfo":"Le informazioni presenti su questo sito non sono rivolte ai residenti degli Stati Uniti, del Belgio o di qualsiasi altro paese al di fuori del Regno Unito e non sono destinate a essere distribuite o utilizzate da nessuna persona, in alcun paese o giurisdizione in cui tale distribuzione o utilizzo si rivelerebbe contrario a leggi o regolamenti locali."
  },
  "headerMsg": {
    "personalDetails1": "Inviando queste informazioni, confermo di accettare le <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Condizioni Generali del Contratto</a>e la <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Politica sulla Privacy</a> di ATFX e di essere contattato in merito alla mia richiesta.",
    "personalDetails2": "Inviando queste informazioni, confermo di accettare le <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Condizioni Generali del Contratto</a>e la <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Politica sulla Privacy</a> di ATFX e di essere contattato in merito alla mia richiesta.",
    "financialDetails": "In qualità di società autorizzata e regolamentata dalla FCA, siamo tenuti a valutare se i nostri prodotti sono adatti a te. Le risposte fornite determineranno se siamo in grado di fornirti i nostri servizi.",
    "experience": "In qualità di società autorizzata e regolamentata dalla FCA siamo tenuti a valutare se i nostri prodotti sono adatti per te. Le risposte fornite determineranno se siamo in grado di fornirti i nostri servizi.",
    "knowledge": "Inviando queste informazioni, confermo di accettare le <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Condizioni Generali del Contratto</a>e la <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Politica sulla Privacy</a> di ATFX e di essere contattato in merito alla mia richiesta.",
    "acknowledgements": "Completando questa richiesta confermi di aver compreso che il FX  e i CFDs tradati con margine sono prodotti con leva e rappresentano un rischio elevato per il tuo capitale investito. Accetti inoltre che è tua responsabilità monitorare il tuo conto e che la natura di questi prodotti potrebbe farti perdere il tuo investimento."
  },
  "changeLanguage": "Cambia lingua",
  "back": "Indietro",
  "next": "Avanti",
  "finish": "Sottoscrivi",
  "personalDetails1": {
    "estimatedTime":"Il tempo stimato per completare la registrazione è di 5 minuti",
    "Gender": "Sesso",
    "genderSelect": {
      "M": "Uomo",
      "F": "Donna",
      "O":"Altro"
    },
    "OtherGender":"Altro Sesso",
    "Title": "Titolo",
    "titleSelect":{
      "Mr":"Sig.",
      "Mrs":"Sig.ra",
      "Ms": "Signorina",
      "Dr":"Dott",
      "Other":"Altro",
    },
    "OtherTitle":"Altro titolo",
    "First_Name": "Nome",
    "Surname": "Cognome",
    "Email": "E-mail",
    "Email_Confirm": "Conferma E-mail",
    "Lang": "Lingua e-mail",
    "emailLanguages": {
      "ENG": "Inglese",
      "CHT": "Cinese tradizionale",
      "CHS": "Cinese semplificato",
      "ARA": "Arabo",
      "ESP": "Spagnolo",
      "ITA": "Italiano",
      "GER": "German",
      "PTG": "Portoghese"
    },
    "MT4_Currency":"Valuta del conto trading",
    "MT4CurrencySelect":{
      "USD":"USD",
      "GBP":"GBP",
      "EUR":"EUR"
    },
    "Account_Type": "Tipo di conto MT4",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting": "Spread betting"
    },
    "Country": "Paese",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR":"Regno Unito",
      "CHN":"Cina",
      "TWN":"Taiwan",
      "ARE":"Emirati Arabi Uniti",
      "ALB":"Albania",
      "AND":"Andorra",
      "AIA":"Anguilla",
      "ATG":"Antigua e Barbuda",
      "ARG":"Argentina",
      "ARM":"Armenia",
      "ABW":"Aruba",
      "AUS":"Australia",
      "AUT":"Austria",
      "AZE":"Azerbaijan",
      "BHS":"Bahamas",
      "BHR":"Bahamas",
      "BGD":"Bangladesh",
      "BRB":"Barbados",
      "BLR":"Bielorussia",
      "BEL":"Belgio",
      "BLZ":"Belize",
      "BEN":"Benin",
      "BMU":"Bermuda",
      "BOL":"Bolivia",
      "BWA":"Botswana",
      "BVT":"Isola Bouvet",
      "BRA":"Brasile",
      "BRN":"Brunei Darussalam",
      "BGR":"Bulgaria",
      "BFA":"Burkina Faso",
      "BDI":"Burundi",
      "KHM":"Cambogia",
      "CMR":"Camerun",
      "CPV":"capo Verde",
      "CYM":"Isole Cayman",
      "CAF":"Repubblica Centrafricana",
      "TCD":"Chad",
      "CHL":"Chile",
      "CCK":"Isole Cocos",
      "COL":"Colombia",
      "COM":"Comoros",
      "COK":"Isole Cook",
      "CRI":"Costa Rica",
      "CIV":"Costa d'Avorio",
      "HRV":"Croazia",
      "CUB":"Cuba",
      "CYP":"Cipro",
      "CZE":"ceco",
      "DNK":"Danimarca",
      "DJI":"Gibuti",
      "DMA":"Dominica",
      "DOM":"Repubblica Dominicana",
      "EGY":"Egitto",
      "SLV":"El Salvador",
      "ERI":"l'Eritrea",
      "EST":"Estonia",
      "ETH":"Etiopia",
      "FJI":"Fiji",
      "FIN":"Finlandia",
      "PYF":"Polinesia francese",
      "GAB":"Gabon",
      "GEO":"Georgia",
      "DEU":"Germania",
      "GHA":"Ghana",
      "GIB":"Gibilterra",
      "GRC":"Grecia",
      "GRL":"Groenlandia",
      "GRD":"Grenada",
      "GLP":"Guadeloupe",
      "GTM":"Guatemala",
      "GIN":"Guinea",
      "GNB":"Guinea-Bissau",
      "HTI":"Haiti",
      "HMD":"Isole Heard e McDonald",
      "HND":"Honduras",
      "HUN":"Ungheria",
      "ISL":"Islanda",
      "IND":"Indonesia",
      "IDN":"Indonesia",
      "IRL":"Irlanda",
      "ISR":"Israele",
      "ITA":"Italia",
      "JAM":"Giamaica",
      "JPN":"Giappone",
      "JOR":"Giordania",
      "KAZ":"Kazakistan",
      "KEN":"Kenia",
      "KIR":"Kiribati",
      "KOR":"Corea del Sud",
      "KWT":"Kuwait",
      "KGZ":"Kyrgyzstan",
      "LVA":"Lettonia",
      "LSO":"Lesoto",
      "LBR":"Liberia",
      "LBY":"Libia",
      "LIE":"Liechtenstein",
      "LTU":"Lituania",
      "LUX":"Lussemburgo",
      "MAC":"Macau",
      "MDG":"Madagascar",
      "MWI":"Malawi",
      "MYS":"Malaysia",
      "MDV":"Maldive",
      "MLI":"Mali",
      "MLT":"Malta",
      "MHL":"Isole Marshall",
      "MTQ":"Martinique",
      "MUS":"Mauritius",
      "MYT":"Mayotte",
      "MEX":"Messico",
      "MDA":"Moldova",
      "MCO":"Monaco",
      "MNG":"Mongolia",
      "MNE":"Montenegro",
      "MSR":"Montserrat",
      "MAR":"Marocco",
      "MOZ":"Mozambico",
      "NAM":"Namibia",
      "NRU":"Nauru",
      "NLD":"Olanda",
      "NCL":"Nuova Caledonia",
      "NZL":"Nuova Zelanda",
      "NIC":"Nicaragua",
      "NER":"Niger",
      "NGA":"Nigeria",
      "NIU":"Niue",
      "NFK":"Isola Norfolk",
      "NOR":"Norvegia",
      "OMN":"Oman",
      "PAK":"Pakistan",
      "PSE":"Palestina",
      "PRY":"Paraguay",
      "PER":"Perù",
      "PHL":"Filippine",
      "PCN":"Pitcairn",
      "POL":"Polonia",
      "PRT":"Portogallo",
      "QAT":"Qatar",
      "ROU":"Romania",
      "RUS":"Russia",
      "RWA":"Ruanda",
      "SHN":"Sant'Elena",
      "KNA":"Saint Kitts e Nevis",
      "LCA":"Santa Lucia",
      "SPM":"Saint Pierre e Miquelon",
      "VCT":"Saint Vincent e Grenadine",
      "WSM":"Samoa",
      "SMR":"San Marino",
      "STP":"Sao Tome e Principe",
      "SAU":"Arabia Saudita",
      "SEN":"Senegal",
      "SRB":"Serbia",
      "SYC":"Seychelles",
      "SLE":"Sierra Leone",
      "SGP":"Singapore",
      "SVK":"Slovacchia",
      "SVN":"Slovenia",
      "ZAF":"Sud Africa",
      "ESP":"Spagna",
      "SUR":"Suriname",
      "SJM":"Svalbard e Jan Mayen",
      "SWZ":"Swaziland",
      "SWE":"Svezia",
      "CHE":"Svizzera",
      "TJK":"Tajikistan",
      "TZA":"Tanzania",
      "THA":"Tailandia",
      "TLS":"Timor Est",
      "TGO":"Andare",
      "TON":"tonga",
      "TTO":"Trinidad e Tobago",
      "TUN":"Tunisia",
      "TUR":"Turkey",
      "TKM":"Turkmenistan",
      "TCA":"Isole Turks e Caicos",
      "TUV":"Tuvalu",
      "UKR":"Ucraina",
      "URY":"Uruguay",
      "UZB":"Uzbekistan",
      "VUT":"Vanuatu",
      "VAT":"Vaticano",
      "VEN":"Venezuela",
      "VNM":"Vietnam",
      "WLF":"Wallis e Futuna",
      "ESH":"Sahara occidentale",
      "ZMB":"Zambia",
      "DZA": "Algeria",
      "AGO": "Angola",
      "BIH": "Bosnia-Erzegovina",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Iraq",
      "RKS": "Kosovo",
      "LBN": "Libano",
      "MKD": "Macedonia",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papua Nuova Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "Indirizzo 1",
    "Addr2": "Indirizzo 2",
    "City": "Città",
    "Postcode": "Codice postale",
    "Building_Name": "Numero / nome dell'edificio",
    "Street": "Strada",
    "Province": "Provincia",
    "birthDate": "Data di nascita",
    "birthYear": "Anno",
    "birthMonth": "Mese",
    "birthSecond": "Giorno",
    "Nationality": "Nazionalità",
    "isHavePass": "Possiedi un passaporto?",
    "PotSelect": {
      "havePot": "Si",
      "noPot": "No"
    },
    "NAT_ID": "Passaporto",
    "Phone": "Cellulare",
    "countryPlace": "Paese di residenza fiscale",
    "TIN": "TIN (numero identificativo del contribuente)",
    "Doc_Type": "Documento di identità",
    "idTypeSelect": {
      "POT": "Passaporto",
      "IDC": "Carta d'identità",
      "DRI": "Patente di guida"
    },
    "Doc_No": "Numero ID",
    "bankCardType": "Tipo di carta bancaria",
    "bankCardTypeSelect": {
      "DR": "Carta di debito",
      "CR": "Carta di credito"
    },
    "Addr_Country":"Indirizzo Paese",
    "Bank_Card_No": "Numero del conto bancario",
    "bankCardNoConfirm": "Conferma del numero bancario",
    "Bank": "Banca",
    "bankSelect": {
      "ICBK": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
      "ABOC": "AGRICULTURAL BANK OF CHINA",
      "PCBC": "CHINA CONSTRUCTION BANK CORPORATION",
      "BKCH": "BANK OF CHINA LIMITED",
      "CMBC": "CHINA MERCHANTS BANK",
      "COMM": "BANK OF COMMUNICATIONS",
      "MSBC": "CHINA MINSHENG BANKING CORPORATION, LIMITED",
      "EVER": "CHINA EVERBRIGHT BANK",
      "SPDB": "SHANGHAI PUDONG DEVELOPMENT BANK",
      "FJIB": "INDUSTRIAL BANK",
      "CIBK": "CITIC BANK CORPORATION LIMITED",
      "PSBC": "POSTAL SAVINGS BANK OF CHINA",
      "SZCB": "SHENZHEN DEVELOPMENT BANK CO., LTD",
      "GDBK": "CHINA GUANGFA BANK",
      "BOSH": "BANK OF SHANGHAI",
      "BJCN": "BANK OF BEIJING",
      "HXBK": "HUA XIA BANK",
      "other": "ALTRO"
    },
    "OtherBank": "Altre banche",
    "Beneficiary_Name": "Nome del beneficiario",
    "SWIFT_Code": "Codice SWIFT della banca",
    "Branch_Name": "Nome della Filiale",
    "Bank_Addr": "Indirizzo Filiale",
    "Branch_Province": "Provincia della Filiale",
    "Branch_City": "Città della Filiale",
    "bankCardImg": "Immagine della. Carta bancaria",
    "IBAN_Code":"Codifica IBAN",
    "docFrontImgword": "Immagine del documento d'identità (anteriore)",
    "docBackImgword": "Immagine del documento d'identità (posteriore)",
    "addressUpload": "Prova di Residenza",
    "addressUpload2": "Prova di Residenza 2",
    "addressUploadTxt1": "documenti accettati: bollette elettricità/gas/estratti conto bancari/permesso di soggiorno/patente/ID/hukou rilasciato entro 3 mesi (se il richiedente non è il capofamiglia, si alleghino le immagini di pagina 1 della richiesta );",
    "addressUploadTxt2": "la prova di residenza non deve essere uguale al documento di identità.",
    "docImgword1": "Allega documento 1",
    "docImgword2": "Allega documento 2",
    "docImgword3": "Allega documento 3",
    "docImgword4": "Allega documento 4",
    "docImgword5": "Allega documento 5",
    "fileUpload":{
      "imgtUpload": "carica",
      "uploadFileArr": [{
        "labelTxt": "Immagine del documento d'identità 1",
        "ValidateNull": "Per favore seleziona",
        "sizeLimit": "L'immagine del documento d'identità 1 non può superare i 5 MB!"
      }, {
        "labelTxt": "Immagine del documento d'identità 2",
        "ValidateNull": "Per favore seleziona",
        "sizeLimit": "L'immagine del documento d'identità 2 non può superare i 5 MB!"
      }, {
        "labelTxt": "Prova di residenza",
        "ValidateNull": "Per favore seleziona",
        "sizeLimit": "Prova di residenza - L'immagine del documento d'identità non può superare i 5 MB!"
      },{
        "labelTxt": "Prova di residenza 2",
        "ValidateNull": "Per favore seleziona",
        "sizeLimit": "Prova di residenza - L'immagine del documento d'identità non può superare i 5 MB!"
      },{
        "labelTxt": "Altri file",
        "ValidateNull": "Per favore seleziona",
        "sizeLimit": "Altri file non possono superare i 5 MB!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"La dimensione del file non può superare i 5 MB",
        "upload_your_documents":"Carica i tuoi documenti",
        "documents_not_ready":"DOCUMENTI NON DISPONIBILI AL MOMENTO?",
        "noe": "*Per aprire un conto devi fornire un'immagine di un documento di identità e di una prova di indirizzo per verificare la tua identità. Non accettiamo: fatture di telefoni cellulari, fatture di carte di credito o di servizi mobili; ricevute di assicurazione; fattura per beni / servizi acquistati.",
        "noe2": "Puoi ancora completare la tua domanda se non hai i documenti richiesti in questo momento.<br/><b>Tuttavia, non potrai tradare finché non riceviamo i documenti richiesti.<b/>",
        "header1": "Prova di identità (Numero di documenti necessari $Logic)",
        "list1": "Richiediamo copie a colori del documento originale di identità / passaporto emesso dal governo. Per le carte, richiediamo sia il lato anteriore che quello posteriore.",
        "list1_new":"Richiediamo una copia chiara e a colori del passaporto originale, con tutti e quattro gli angoli visibili.",
        "header2": "Prova di residenza (Numero di documenti necessari $Logic)",
        "list2": "<ol class='list-style-position:inside'><li>Bolletta (acqua/elettricità/gas) - emessa negli ultimi 3 mesi.</li><li>Estratto conto Bancario emesso negli ultimi 3 mesi,</li><li>Possiamo accettare permessi di soggiorno /titoli di proprietà, incluso il cinese Hukou, ma tali documenti sono soggetti a revisione.</li><li>È necessario fornire un contratto di affitto in corso e una bolletta (gas/acqua/elettricità) degli ultimi 3 mesi.</li><li>Una ricevuta fiscale recente del pagamento di tasse, se rilasciata negli ultimi 6 mesi.</li><li>Una bolletta del telefono fisso emessa negli ultimi 3 mesi.</li></ol>",
        "strongTxt": "<strong>Come parte dei nostri requisiti normativi, potremmo richiedere anche documenti aggiuntivi in relazione alla tua richiesta.</strong>"
      }
    },
    "isHaveCitizen": "Sei un cittadino degli Stati Uniti d'America?",
    "CitizenSelect": {
      "Y": "Sì",
      "N": "No"
    },
    "citizen_Tip":"Sfortunatamente, non possiamo aprire un conto di trading per i cittadini statunitensi.",
    "isDualCitizenship": "Sei fiscalmente residente in un Paese diverso da quello in cui risiedi?",
    "DualCitizenshipSelect": {
      "Y": "Sì",
      "N": "No"
    },
    "Dual_Nationality":"Paese",
    "IS_Politically_Person": "Sei una Persona Politicamente Esposta?",
    "IS_Politically_Exposed":'Le persone politicamente esposte sono persone fisiche che ricoprono o hanno ricoperto in passato importanti incarichi pubblici presso la propria Repubblica o presso altri paesi,ma anche i familiari più stretti e i soggetti che sono notoriamente stretti collaboratori di tali persone:<br/>Si conviene che, allo scopo della presente definizione, per "importanti incarichi pubblici" si intendono le seguenti funzioni pubbliche:<br/>(a) capi di Stato o di governo, ministri, i loro vice e assistenti;<br/>(b) membri del Parlamento o di analoghi organi legislativi;<br/>(c) membri degli organi direttivi di partiti politici;<br/>(d) membri di corti supreme, corti costituzionali o altri organi giudiziari di alto livello,le cui pronunce non sono appellabili, se non in casi eccezionali;<br/>(e) membri di corti dei conti o di consigli di amministrazione delle banche centrali;<br/>(f) ambasciatori, incaricati di affari e ufficiali di alto rango nelle forze armate;<br/>(g) membri di organi amministrativi, gestionali o di supervisione di imprese a partecipazione statale;<br/>(h) direttori, vicedirettori, membri dei consigli di amministrazione, o altre cariche equivalenti, di organizzazioni internazionali;<br/>(i) sindaci: Si conviene che nessuna delle funzioni pubbliche di cui ai precedenti punti da (a)<br/>a (i) debba essere riferita a funzionari che coprono cariche di medio rango o di ridotta esperienza;<br/>Si conviene ancora che per "familiari più stretti di persone politicamente esposte" si intendono i seguenti:<br/>(a) coniugi o soggetti equivalenti al coniuge di persone politicamente esposte;<br/>(b) figli e loro coniugi, o soggetti equivalenti al coniuge, di persone politicamente esposte;<br/>(c) genitori di persone politicamente esposte; Si conviene infine che per "soggetti che sono notoriamente<br/>stretti collaboratori di persone politicamente esposte" si intendono persone fisiche che:<br/>(a) sono notoriamente titolari di diritti reali congiunti in persone giuridiche o predisposizioni giuridiche,o in altri stretti rapporti commerciali, con persone politicamente esposte;<br/>(b) sono i titolari esclusivi di diritti reali in persone giuridiche o predisposizioni giuridiche che sono state notoriamente realizzate a beneficio effettivo di persone politicamente esposte.<br/>',
    "IS_Politically_Person_Select": {
      "Y": "Sì",
      "N": "No"
    },
  },
  "financialDetails": {
    "Emp_Status": "Stato di occupazione",
    "employmentStatusSelect": {
      "b": "Occupato",
      "a": "Lavoratore autonomo",
      "c": "Studente",
      "e": "Pensionato",
      "d": "Disoccupato"
    },
    "Freelance_OwnACompany": "Libero professionista/Possiedo una società",
    "Freelance_OwnACompany_select": {
      "0": "Libero professionista",
      "1": "Possiedo una Società"
    },
    "Position": "Posizione",
    "FD_Position_select": {
      "0": "Manager di grado superiore ad es. Amministratore delegato, Capo ufficio finanziaro ecc",
      "1": "Senior Manager",
      "2": "General / Middle Manager",
      "3": "Supervisore",
      "4": "Operaio",
      "5": "Staff",
      "6": "Junior",
      "7": "Altro (Per favore specifica)"
    },
    "Employer": "Nome della Società",
    "Biz_Nature": "Natura dell'attività",
    "financialRegulator": "Il tuo datore di lavoro è autorizzato dalla FCA o da un'altra autorità di regolamentazione finanziaria?",
    "financialRegulatorSelect": {
      "Y": "Sì",
      "N": "No"
    },
    "Industry_Sector": "Industria/Settore",
    "Industry_Sector_select": {
      "0": "Contabilità",
      "1": "Pubblicità / Media",
      "2": "Computer / Internet / Comunicazione / Elettronica",
      "3": "Istruzione / Formazione",
      "4": "Energia / Materie Prime",
      "5": "Servizi finanziari (Finanza / Banca / Assicurazioni)",
      "6": "Governo / Nonprofit",
      "7": "Risorse umane",
      "8": "Legale",
      "9": "Marketing",
      "10": "Logistica / Trasporti",
      "11": "Farmaceutica / Medicale",
      "12": "Servizi professionali",
      "13": "Immobiliare / Edilizia",
      "14": "Settore terziario",
      "15": "Commercio / Consumatore / Produzione / Operazioni",
      "16": "Altro (Per favore specifica)"
    },
    "Annual_Income": "Reddito annuale",
    "Annual_Income_word":"include tutti i redditi da lavoro compresi stipendi, pensioni, interessi, dividendi, redditi da locazione ecc.",
    "Total_Saving_Investments": "Risparmio totale e investimenti",
    "Total_Saving_word": "Comprende tutti i conti bancari o di intermediazione, certificati, obbligazioni, investimenti sul mercato monetario ecc.",
    "Total_Saving_Investments_select": {
      "0": "Oltre 500.000 USD",
      "1": "200,000 USD - 499,999 USD",
      "2": "100,000 USD - 199,999 USD",
      "3": "50,000 USD - 99,999 USD",
      "4": "25,000 USD - 49,999 USD",
      "5": "10,000 USD - 24,999 USD",
      "6": "2,000 USD - 9,999 USD",
      "7": "Meno di 2.000 USD"
    },
    "liquidNetWorth": "Valore netto liquido (esclusa residenza privata)",
    "financialPortfolio": "Valore del tuo portafoglio finanziario",
    "annualIncomeSelect": {
      "0": "Oltre 200,000 USD",
      "1": "100,000 USD -199,999 USD",
      "2": "50,000 USD -99,999 USD",
      "3": "25,000 USD -49,999 USD",
      "4": "10,000 USD -24,999 USD",
      "5": "Meno di 10,000 USD"
    },
    "fundsSource": "Fonte del reddito",
    "fundsSourceSelect": {
      "0": "Nessuna",
      "1": "Reddito familiare e del partner",
      "2": "Assistenza governativa",
      "3": "Prestito / Credito",
      "4": "Pensione",
      "5": "Reddito immobiliare",
      "6": "Altro (Per favore specifica)"
    },
    "Funds_Source": "Altre fonti di reddito",
    "Intend_Deposit": "Quanto intendi depositare?",
    "intendDepositSelect": {
      "0": "Oltre 100,000 USD",
      "1": "80,000 USD – US$99,999 USD",
      "2": "50,000 USD – US$79,999 USD",
      "3": "25,000 USD – US$49,999 USD",
      "4": "10,000 USD – US$24,999 USD",
      "5": "Meno di 10,000 USD"
    },
    "Other_Industry_Sector": "Altro settore industriale",
    "Other_Position": "Altra posizione",
    "Other_Biz_Nature": "Altra natura dell'attività",
    "Other_Funds_Source": "Altre fonti di reddito",
    "Afford_To_Lose_Error":"I CFD sono un prodotto ad alto rischio, ecco perchè devi operare impiegando esclusivamente somme di denaro che puoi permetterti di perdere.",
    "Afford_To_Lose":"Ti puoi permettere di perdere il capitale che stai per investire?",
    "Afford_To_Lose_Select": {
      "Y": "Sì",
      "N": "No"
    },
    "Open_Trading_Account":"Perché vuoi aprire un conto di trading con ATFX?",
    "Open_Trading_Account_Select": {
      "0": "Speculazione sui mercati finanziari a medio/breve termine",
      "1": "Copertura a medio/breve termine delle posizioni esposte su investimenti esistenti",
      "2": "Speculazione sui mercati finanziari a medio/breve termine e copertura a medio/breve termine delle posizioni esposte su investimenti esistenti"
    },
    "ATFX_Client_Pro":"ATFX ritiene che i propri prodotti siano adatti solo ai clienti che si pongono gli obiettivi sopra elencati. Coloro che intendono perseguire altri obiettivi sono pregati di non procedere con la richiesta di apertura del conto.",
    "Annual_Income_Total":"Indicare il proprio reddito annuale effettivo",
    "Saving_Investments_Money":"Indicare i propri risparmi e investimenti totali effettivi",
  },
  "Experience": {
    "experienceLabel": "Negli ultimi tre anni, con che frequenza hai tradato i seguenti strumenti finanziari per i quali hai preso tu le decisioni di trading?",
    "Futures_Options": "Futures / Opzioni",
    "Futures_Options_select": {
      "0": "In oltre 40 occasioni",
      "1": "Da 15 a 40 occasioni",
      "2": "Da 1 a 15 occasioni",
      "3": "Mai"
    },
    "CFDs_Spread_Bets": "CFD, Derivati ​​su Forex o Spread Betting",
    "CFDs_Spread_Bets_select": {
      "0": "In oltre 40 occasioni",
      "1": "Da 15 a 40 occasioni",
      "2": "Da 1 a 15 occasioni",
      "3": "Mai"
    },
    "Derivative_Trade_over2": "Negli ultimi dodici mesi, hai effettuato almeno due operazioni a trimestre su Spot FX / CFD / Opzioni / Futures o Spread Betting per le quali hai preso tu le decisioni di trading?",
    "Derivative_Trade_over2_select": {
      "b": "Sì",
      "a": "No"
    },
    "Derivative_Trade_over40": "Negli ultimi tre anni, hai effettuato quaranta operazioni in un periodo di dodici mesi su Spot FX / CFD / Opzioni / Futures o Spread Bet?",
    "Derivative_Trade_over40_select": {
      "b": "Sì",
      "a": "No"
    },
    "Average_Annual_Investment":"Qual è stato il volume medio degli importi da te investiti annualmente nelle passate transazioni con prodotti finanziari come quelli scelti sopra?",
    "Average_Annual_Investment_select": {
      "0": "Non ho mai fatto investimenti",
      "1": "Meno di 500$ ",
      "2": "Tra 500$ e 2.500$",
      "3": "Tra 2.500$ e 10.000$",
      "4": "Oltre 10.000$"
    },
    "Average_Leverage_Level":"Qual è stato il livello medio di leva da te utilizzato nelle passate operazioni con prodotti finanziari come quelli scelti sopra?",
    "Average_Leverage_Level_select": {
      "0": "Non ho mai usato prodotti con leva",
      "1": "Fino a 1:10",
      "2": "Tra 1:10 - 1:25",
      "3": "Tra 1:25 - 1:50",
      "4": "Tra 1:50 - 1:100",
      "5": "Oltre 1:100"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "Hai mai lavorato in una posizione che richiedeva la conoscenza del trading dei derivati?",
    "DT_Work_Experience_select": {
      "txt1": "Sì",
      "txt2": "No",
      "subTxt1": "Ho almeno 3 anni di esperienza lavorativa",
      "subTxt2": "Ho meno di 3 anni di esperienza lavorativa o almeno un anno di esperienza in investimenti personali."
    },
    "DT_Qualification": "Hai una qualifica che ti ha permesso di avere una comprensione specifica del trading dei derivati?",
    "DT_Qualification_select": {
      "txt1": "Sì",
      "txt2": "No",
      "subTxt1": "Sono in possesso di una qualifica professionale o laurea CFA, MBA, BSC o MA",
      "subTxt2": "Ho una qualifica o laurea in finanza, economia, contabilità o un campo simile"
    },
    "K_Sell_Position": "Se vendi 1 lotto di ORO (XAUUSD) al prezzo di 1200 e il mercato si sposta a un prezzo di 1300, stai perdendo o guadagnando soldi?",
    "K_Sell_Position_b": "Se vendi 1 lotto di oro XAUUSD.sb al prezzo di 1200 e il mercato si sposta a un prezzo di 1300, guadagneresti o perderesti?",
    "K_Sell_Position_select": {
      "0": "Perdendo",
      "1": "Guadagnando"
    },
    "Closing_Order": "Per evitare che il tuo conto perda più di un certo importo predeterminato, all'apertura di un nuovo ordine limiteresti la tua perdita utilizzando uno stop loss o un take profit?",
    "Closing_Order_select": {
      "0": "Stop Loss",
      "1": "Take Profit"
    },
    "K_Profit_Change": "Comprendi che una leva maggiore determina un rischio maggiore per il tuo capitale quando scambi i prodotti CFD con leva finanziaria?",
    "K_Profit_Change_b": "Comprendi che incrementando la leva sul conto aumenta anche il rischio per il tuo capitale quando scambi i prodotti FX e CFDs con leva finanziaria?",
    "K_Profit_Change_select": {
      "0": "Sì",
      "1": "No"
    },
    "K_Margin": "Quale sarebbe il margine richiesto per 1 lotto (100.000 USD/JPY, se il margine è dell'1% (leva 20: 1)",
    "K_Margin_select": {
      "0": "5,000 USD",
      "1": "50,000 USD",
      "2": "100,000 USD"
    }
  },
  "Acknowledgements": {
    "A1": "Confermo che le informazioni a te fornite sono accurate e complete e mi impegno a notificare eventuali modifiche a tali informazioni.",
    "A2": "Ho letto, compreso e accettato di essere vincolato dall'Accordo con il Cliente di AT Global Markets che mi è stato fornito.",
    "A2_txt": "L'Accordo con il Cliente di AT Global Markets",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>L'Accordo con il Cliente di AT Global Markets</a>",
    "A3": "Ho letto, compreso e accettato la Dichiarazione di Trasparenza sui Rischi di AT Global Markets che mi è stata fornita",
    "A3_txt": "la Dichiarazione di Trasparenza sui Rischi di AT Global Markets",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'> la Dichiarazione di Trasparenza sui Rischi di AT Global Markets</a>",
    "A4": "Ho letto, compreso e accettato la Politica di Esecuzione degli Ordini di AT Global Markets e la Politica sui Conflitti che mi sono state fornite.",
    "A4_txt": "la Politica di Esecuzione degli Ordini di AT Global Markets e la Politica sui Conflitti di AT Global Markets",
    "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>la Politica di Esecuzione degli Ordini di AT Global Markets</a> e <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>la Politica sui Conflitti di AT Global Markets</a>",
    "header": "Completando questa richiesta confermi di aver compreso che il FX con Margine e i CFD sono prodotti con leva e rappresentano un rischio elevato per il tuo capitale investito. Accetti inoltre che è tua responsabilità monitorare il tuo conto e che la natura di questi prodotti potrebbe farti perdere più del tuo investimento iniziale.",
    "age": "Confermi di avere almeno 18 anni;",
    "message": "Le informazioni fornite in questa richiesta sono vere e corrette e ti impegni a notificarci eventuali modifiche a tali informazioni;",
    "receive": {
      "text": "Hai letto, compreso e accettato i nostri",
      "list": [
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>Condizioni Generali del Contratto e Informativa sul Rischio</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>Politica di Esecuzione degli Ordini</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Politica sulla Privacy</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>Informativa di Introducer Broker</a>",
        "<a href='https://www.atfx.com/it/informazioni-legali' target='_blank'>Documento Informativo Chiave</a>"
      ]
    },
    "A_select": {
      "text": "Ho letto, compreso e accettato tutti i termini.",
      "Y": "Ho letto, compreso e accettato tutti i termini."
    },
    "checkboxTxt_A1": "Ho letto, compreso e accettato tutti i termini.",
    "checkboxTxt_A2": "Comprendo che i CFDs sono prodotti con leva e le loro prestazioni possono essere volatile.",
    "checkboxTxt_A3": "Comprendo che è mia responsabilità monitorare e gestire il mio conto.",
    "checkboxTxt_A4": "Comprendo che quando si scambiano prodotti con leva è possibile perdere più dell'investimento iniziale.",
    "Marketing_Email_Preference": "Accetto di ricevere communicazioni di marketing da ATFX.",
    "Marketing_automatically": "Comprendo che posso scegliere di non ricevere comunicazioni di marketing immediatamente contattando il <a href='https://www.atfx.com/it/chi-siamo/contatti' target='_blank'>servizio clienti</a>.",
    "Marketing_Email_Preference_select":{
      "Y":"Sì",
      "N":"No"
    },
    "Hear_ATFX":"Come sei venuto a conoscenza di ATFX?",
    "OtherHearATFX":"Altri modi",
    "hearATFXSelect":{
      "Recommendation":"Raccomandazione",
      "SearchEngine":"Motore di ricerca",
      "MediaAdvertising":"Pubblicità",
      "Partnership":"Partnership",
      "Other":"Altro"
    },
    "Parent_IB_Code": "Codice di riferimento",
    "Rec_Type": "Tipo di referente",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "Nessun referente"
    },
    "recGroup": "Gruppo referente",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "Per favore seleziona",
      "OtherGender":"Per favore inserisci un altro genere",
      "Title": "Per favore seleziona",
      "OtherTitle":"Per favore inserisci un altro titolo",
      "First_Name": "Nome",
      "Surname": "Cognome",
      "Email": "Indirizzo email",
      "Email_Confirm": "Conferma email",
      "Lang": "Per favore seleziona",
      "Country": "Per favore seleziona",
      "MT4_Currency":"Per favore seleziona",
      "Account_Type":"Per favore seleziona",
      "Addr": "Indirizzo",
      "Addr2": "Indirizzo 2",
      "City": "Città",
      "Postcode": "Codice postale",
      "Building_Name": "Numero / nome dell'edificio",
      "Street": "Strada",
      "Province": "Provincia",
      "Birth_Date_Year": "Data di nascita",
      "Birth_Date_Month": "Data di nascita",
      "Birth_Date_Day": "Data di nascita",
      "Nationality": "Nazionalità",
      "isHavePass": "Per favore seleziona",
      "NAT_ID": "Passaporto",
      "Phone": "Telefono",
      "Doc_Type": "Per favore seleziona",
      "Doc_No": "Numero del documento di identità",
      "Addr_Country": "Per favore seleziona",
      "Bank_Card_No": "Numero del conto bancario",
      "Bank": "Per favore seleziona",
      "OtherBank": "Altre banche",
      "Beneficiary_Name": "Nome del beneficiario",
      "Branch_Name": "Nome della Filiale",
      "Bank_Addr": "Indirizzo Filiale",
      "Branch_Province": "Provincia della Filiale",
      "Branch_City": "Città della Filiale",
      "FD_Emp_Status": "Per favore seleziona",
      "FD_Position": "Posizione",
      "FD_Employer": "Nome della Società",
      "FD_Biz_Nature": "Ti preghiamo di inserire le caratteristiche di business",
      "FD_FCA_AUTH": "Per favore seleziona",
      "FD_Annual_Income": "Per favore seleziona",
      "FD_Liquid_Net_Worth": "Per favore seleziona",
      "FD_Portfolio_Value": "Per favore seleziona",
      "FD_Funds_Source": "Per favore seleziona",
      "FD_Funds_Other": "Per favore seleziona",
      "E_Forex_Exp": "Per favore seleziona",
      "E_Forex_Trade_No": "Per favore seleziona",
      "E_Derivative_Exp": "Per favore seleziona",
      "E_Derivative_Trade_No": "Per favore seleziona",
      "E_Equity_Exp": "Per favore seleziona",
      "E_Equity_Trade_No": "Per favore seleziona",
      "K_A": "Per favore seleziona",
      "K_A_Detail": "Dettagli",
      "K_B": "Per favore seleziona",
      "K_B_Detail": "Dettagli",
      "K_C": "Per favore seleziona",
      "K_C_Detail": "Dettagli",
      "K_D": "Per favore seleziona",
      "K_E": "Per favore seleziona",
      "K_F": "Per favore seleziona",
      "K_G": "Per favore seleziona",
      "K_H": "Per favore seleziona",
      "A1": "Per favore seleziona",
      "A2": "Per favore seleziona",
      "A3": "Per favore seleziona",
      "A4": "Per favore seleziona",
      "checkList":"Per favore seleziona",
      "Emp_Status": "Per favore seleziona",
      "Freelance_OwnACompany": "Per favore seleziona",
      "Industry_Sector": "Per favore seleziona",
      "Position": "Per favore seleziona",
      "Employer": "Nome della Società",
      "Biz_Nature": "Ti preghiamo di inserire le caratteristiche di business",
      "Annual_Income": "Per favore seleziona",
      "Total_Saving_Investments": "Per favore seleziona",
      "Funds_Source": "Per favore seleziona",
      "Intend_Deposit": "Per favore seleziona",
      "Other_Industry_Sector": "Altro settore industriale",
      "Other_Position": "Altra posizione",
      "Other_Biz_Nature": "Altra natura dell'attività",
      "Other_Funds_Source": "Altre fonti di reddito",
      "Futures_Options": "Per favore seleziona",
      "CFDs_Spread_Bets": "Per favore seleziona",
      "Derivative_Trade_over2": "Per favore seleziona",
      "Derivative_Trade_over40": "Per favore seleziona",
      "DT_Work_Experience": "Per favore seleziona",
      "DT_Qualification": "Per favore seleziona",
      "K_Sell_Position": "Per favore seleziona",
      "Closing_Order": "Per favore seleziona",
      "K_Profit_Change": "Per favore seleziona",
      "K_Margin": "Per favore seleziona",
      "IBAN_Code":"Si prega di inserire il codice IBAN",
      "Hear_ATFX":"Per favore seleziona",
      "OtherHearATFX":"Per favore, inserisci",
      "Rec_Type":"Per favore seleziona",
      "Parent_IB_Code":"Codice di riferimento",
      "Afford_To_Lose":"Per favore seleziona",
      "Open_Trading_Account":"Per favore seleziona",
      "Annual_Income_Total":"Si prega di accedere",
      "Saving_Investments_Money":"Si prega di accedere",
      "IS_Politically_Person":"Per favore seleziona",
      "isDualCitizenship":"Per favore seleziona",


    }
  },
  "errors": {
    "fieldIsRequired": "Indirizzo email",
    "invalidFormat": "Formato non valido!",
    "numberTooSmall": "Il numero è troppo piccolo! Minimo: {0}",
    "numberTooBig": "Il numero è troppo grande! Massimo: {0}",
    "invalidNumber": "Numero non valido",
    "textTooSmall": "La lunghezza del testo è troppo corta! Attuale: {0}, Minimo: {1}",
    "textTooBig": "La lunghezza del testo è troppo grande! Attuale: {0}, Massimo: {1}",
    "thisNotText": "Questo non è un testo!",
    "thisNotArray": "Questa non è una serie!",
    "selectMinItems": "Seleziona un minimo di {0} elementi!",
    "selectMaxItems": "Seleziona massimo {0} elementi!",
    "invalidDate": "Data non valida!",
    "dateIsEarly": "La data è troppo vicino! Attuale: {0}, Minimo: {1}",
    "dateIsLate": "La data è troppo lontana! Attuale: {0}, Massimo: {1}",
    "invalidEmail": "L’indirizzo e-mail non è valido.",
    "invalidURL": "URL non valido!",
    "invalidCard": "Formato della carta non valido!",
    "invalidCardNumber": "Numero di carta non valido!",
    "invalidTextContainNumber": "Testo non valido! Non può contenere numeri o caratteri speciali",
    "invalidTextContainSpec": "Testo non valido! Impossibile inserire caratteri speciali",
    "incorrectComfirm": "I due input sono incoerenti",
    "invalidBirthDate": "Si accettano richieste solo di persone che hanno tra i 18 e i 69 anni",
    "invalidParentClnID": "Inserire un numero inferiore a 12 cifre!",
    "docImgFrontSizeLimit": "L'immagine del documento d'identità (anteriore) non può superare i 2 MB!",
    "docImgBackSizeLimit": "L'immagine del documento d'identità (posteriore) non può superare i 2 MB!",
    "imgSizeLimit": "L'immagine della prova di residenza non può superare i 2MB.",
    "bankCardNoTopTwo": "Le prime due cifre della carta di credito non sono valide.",
    "bankCardNoLnegth": "Inserisci un numero di 16-19 cifre",
    "dayErrors1": "Questo è un anno bisestile e non c'è il giorno",
    "dayErrors2": "Per quest'anno, il giorno non esiste",
    "dayErrors3": "Il giorno non esiste in questo mese",
    "emailError": "L'indirizzo email non è disponibile",
    "DocTypeNoError": "Il numero del documento d'identità non è corretto",
    "DocFrontImg": "Ti preghiamo di caricare l'immagine del documento d'identità (anteriore)",
    "DocBackImg": "Ti preghiamo di caricare l'immagine del documento d'identità (posteriore)",
    "ProofofAddress": "Ti preghiamo di caricare la prova di residenza",
    "Doc_No": "Ti preghiamo di inserire il numero del documento di identità",
    "Phone": "Telefono",
    "Bank_Card_No": "Numero del conto bancario",
    "Birth_Date_Second": "Data di nascita",
    "phoneError": "Formato del telefono errato",
    "bankNumError": "Formato del numero del conto bancario errato",
    "numType": "Inserisci il numero",
    "bankCodeError":"Il formato di codifica IBAN non è corretto"
  },
  "messages": {
    "fieldsWillBeReset": "Tutti gli input verranno ripristinati, per favore conferma",
    "completeTip1": "Ti preghiamo di controllare la tua email. Grazie.",
    "completeTip2": "Completato! Grazie.",
    "noCompleteTip": "Siamo spiacenti, le informazioni di un input non sono corrette e l'operazione precedente non è avvenuta con successo",
    "emailAndDocInvalid": "L'indirizzo email è già stato utilizzato",
    "phoneAndDocInvalid": "Il numero di telefono è già stato utilizzato",
    "IBCodeInvalid": "Codice referente errato",
    "invalidBankCardNo": "Il numero della carta bancaria non è corretto. Ti preghiamo di controllare prima di inviarlo",
    "beneficiaryName": "Per favore utilizza il Nome del Conto indicato sul conto bancario, terze parti non sono consentite",
    "employerName": "Non contatteremo il tuo datore di lavoro",
    "errors": "Errori di rete",
    "unSelect":"Per favore seleziona",
    "selectEmpStatusTip":"Perche 'Hai scelto di pensionati, studenti e Disoccupati in un contratto di prodotti, Le Differenze di prezzo per i prodotti ad alto rischio, Al Fine di proteggere gli interessi Vitali, VI forniremo il Materiale in esame SE sei adatto per altri prodotti che offrono."
  },
  "ModalMsg": {
    "showModal": {
      "content": "Sulla base delle informazioni che hai fornito nella richiesta di apertura dell'account cliente AT Global Markets Limited (UK) Limited, riteniamo necessario informarti che la negoziazione di CFD e forex con leva, per te, potrebbero, non essere appropriati . Il trading con leva comporta un alto grado di rischio per il tuo capitale. La Società fornisce solo un servizio di esecuzione ---  ai suoi clienti e dovrai fare affidamento sulle tue abilità e giudizio quando fai trading su questi mercati.<br/><br/><b>Nota: AT Global Markets (UK) Limited offre conti demo con cui è possibile esercitarsi nel trading con le condizioni e i prezzi reali di mercato, la Società ti incoraggia a provare questa soluzione prima di fare trading con denaro reale.</b><br/><br/>Se desideri ancora aprire un account cliente con AT Global Markets (UK) Limited, conferma questo accettando la seguente dichiarazione.",
      "checkboxTxt":"Comprendo che il trading di CFD e il forex trading con leva finanziaria comportano un alto grado di rischio per il mio capitale. Sono in grado di valutare i rischi connessi e desidero continuare con la mia domanda di apertura di un account.",
      "errorsTxt": "Per favore seleziona",
      "btn": "Conferma"
    },
    "showAlert": {
      "title": "consiglio:",
      "submitBtnTxt": "Conferma",
      "cancleBtnTxt": "Annulla",
      "confirmBtnTxt": "Conferma"
    }
  },
  "ratesModalMsg": {
    "p3_1": "ATTENZIONE - MODIFICHE AL MARGINE PER TUTTI GLI OPERATORI COMMERCIALI",
    "p3_2": "Caro Richiedente,",
    "p3_2_1": "",
    "p3_3": "Si prega di notare, a causa delle modifiche dell'Autorità europea degli strumenti finanziari e dei mercati (ESMA) per i commercianti al dettaglio, tutti i nuovi clienti ATFX dal 2 luglio utilizzeranno i nuovi tassi di margine.",
    "p3_4": "Le modifiche includono un limite alla quantità di leva finanziaria che può essere offerta ai commercianti al dettaglio.",
    "p4_1": "FX principali: coppie di valute contenenti due dei seguenti: USD, EUR, JPY, GBP, CAD, CHF - 3,33% (Leva 30: 1)",
    "p4_2": "FX secondario: tutte le altre coppie di valute - 5% (leva 20: 1)",
    "p4_3": "Principali indici: UK100, FRA40, ESP35, US30, SPX500, NAS100, JP225, AUS200 5% (Leverage 20: 1)",
    "p4_4": "Oro: 5% (Leverage 20: 1)",
    "p4_5": "Materie prime: 10% (leva 10: 1)",
    "p5_1": "Protezione del saldo negativo",
    "p5_2": "L'ESMA ha introdotto una nuova regola per garantire che tutti i commercianti al dettaglio non possano mai perdere più del denaro disponibile sul proprio conto. Se il tuo saldo diventa negativo, ATFX sarà obbligato a riportare il saldo a zero, senza alcun costo per te, il cliente.",
    "p5_3": "Regola di chiusura del margine del 50%.",
    "p5_4": "ATFX offre già la regola di chiusura del margine del 50% a tutti i clienti.",
    "p5_5": "Se desideri finalizzare la tua domanda e aprire un conto di vendita al dettaglio ATFX, perfavore seleziona qui sotto.",
    "p5_6": "Riconosco e accetto le nuove condizioni per i clienti al dettaglio",
    "p6_2": "Per favore acconsenti ",
    "btnText": "SOTTOSCRIVI"
  },
  "verifyMsg": {
    "phone_exist": "Questo numero di telefono è già stato utilizzato, si prega di utilizzare un numero di telefono alternativo.",
    "email_exist": "Questo indirizzo email è già stato utilizzato, si prega di utilizzare un indirizzo email alternativo.",
    "phoneAndemail_exist": "Il numero di telefono e l'indirizzo e-mail sono già stati utilizzati, si prega di utilizzare un numero di telefono alternativo e un nuovo indirizzo e-mail.",
  }
}



// WEBPACK FOOTER //
// ./src/lang/it.js